import { render, staticRenderFns } from "./LiveSocial.vue?vue&type=template&id=16985778&scoped=true"
import script from "./LiveSocial.vue?vue&type=script&lang=js"
export * from "./LiveSocial.vue?vue&type=script&lang=js"
import style0 from "./LiveSocial.vue?vue&type=style&index=0&id=16985778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16985778",
  null
  
)

export default component.exports